import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const GrayWrap = styled.div`
    display: block;
    position: relative;
    width: 100%;
    background-color: ${COLORS.lightGrey};
`;

export const InnerWrap = styled.div`
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 8%;

    @media screen and (max-width: 1188px) {
        padding: 0 5%;
    }
`;

export const DetailNews = styled.div`
    display: block;
    position: relative;
    width: 100%;
    margin-bottom: -50px;
    padding-top: 12px;
    padding-bottom: 60px;
    background-color: ${COLORS.white};
    overflow: hidden;
`;

export const DetailContent = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    backgorund-color: grey;
    max-width: 760px;
    padding: 30px 20px;
    margin-right: auto;

    @media screen and (max-width: 768px) {
        padding: 30px 0;
    }
`;

export const DetailLogoWrap = styled.div`
    display: none;
`;

export const DetailPictureWrap = styled.div`
    display: flex;
`;

export const DetailPicture = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const DetailDescription = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 15px;
`;

export const DetailDate = styled.div`
    ${FONTS.XS};
    white-space: nowrap;
`;

export const DetailTitle = styled.h1`
    ${FONTS.H2};
`;

export const DetailText = styled.div`
    display: block;
    width: 100%;
    ${FONTS.S};
    color: ${COLORS.black};

    & > p {
        margin-bottom: 20px;
    }

    & > ul {
        list-style: initial;
        margin-left: 50px;
        margin-bottom: 20px;
    }

    & img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }
`;

export const DetailCrumbsWrap = styled.div`
    display: flex;
    padding: 20px;

    @media screen and (max-width: 768px) {
        padding: 0;
    }
`;

export const Sepatator = styled.div`
    margin: 0 3px;
    color: ${COLORS.darkGrey};
`;

export const DetailCrumb = styled.a`
    ${FONTS.MediumS};
    color: ${COLORS.darkGrey};
    cursor: pointer;
`;

export const DetailTagsWrap = styled.div`
    margin-top: 10px;
`;

export const SocialWrap = styled.div`
    margin: 30px 0 10px;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
`;
